"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitBoxProps = exports.boxMixin = exports.Box = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _splitProps = require("../../utils/splitProps");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * All the system functions for Box
 */
var boxMixin = (0, _styledSystem.compose)(_styledSystem.background, _styledSystem.border, _styledSystem.color, _styledSystem.flexbox, _styledSystem.layout, _styledSystem.position, _styledSystem.space, _styledSystem.textAlign);
/**
 * Box is just a `View` or `div` (depending on the platform) with common styled-systems
 * hooks.
 */

exports.boxMixin = boxMixin;

var Box = _styledComponents.default.div.withConfig({
  displayName: "Box",
  componentId: "sc-15se88d-0"
})(["", ""], boxMixin);

exports.Box = Box;
Box.displayName = "Box";
/** Splits out props into valid and invalid BoxProps */

var splitBoxProps = (0, _splitProps.splitProps)(boxMixin);
exports.splitBoxProps = splitBoxProps;
//# sourceMappingURL=Box.js.map